"use strict";

/**
 * @namespace
 */
gc.gis.widget = gc.gis.widget || {};

/**
 * @classdesc
 * Basisklasse für Widgets.
 *
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {string} options.id HTML-ID dieses Widgets
 * @param {string} options.target HTML-ID des Zielkontainers
 * @param {number} [options.order] optionaler Anordnungsindex
 * @param {string} [options.className=''] CSS-Klasse(n) für den Container
 */
gc.gis.widget.GCWidget = function( options )
{
	gc.gis.GCObservable.call( this );

	gc.gis.assert.isSet( options );

	this.id        = options.id;
	this.target    = options.target;
	this.order     = options.order;
	this.className = options.className || '';
	this.element   = null;
};
gc.gis.widget.GCWidget.prototype = Object.create( gc.gis.GCObservable.prototype );

/**
 * Rendert das Widget.
 *
 * @protected
 * @abstract
 * @method
 *
 * @return {jQuery} Root-Element des Widgets
 */
gc.gis.widget.GCWidget.prototype._render = gc.gis.abstractMethod;

/**
 * Gibt das jQuery-Root-Element des Widgets zurück.
 * Ruft ggf. {@link gc.gis.widget.GCWidget._render} auf, falls das Element noch
 * nicht existiert.
 *
 * @public
 * @return {jQuery}
 */
gc.gis.widget.GCWidget.prototype.getElement = function()
{
	if( !this.element )
	{
		this.element = this._render();
	}
	return this.element;
};

/**
 * Gibt das Widget als HTML-String aus.
 *
 * @public
 * @return {string}
 */
gc.gis.widget.GCWidget.prototype.toHTML = function()
{
	return this.getElement().prop('outerHTML');
};

